module.exports = __webpack_public_path__ + "static/01-5cf2ff7d18801b8ba3815f858a12ee0c.jpg";